import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  GET,
  POST,
  PUT,
  DELETE,
  t, // นำเข้าฟังก์ชัน t
} from "../../components/CustomComponent.js";

export default class RolesPermissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,

      filter_search: "",

      active_tab: "admin",
      selected_company: "CMMS Service Co. (Service Provider)",

      data: [],
      active_role_id: 1,

      permissions: {
        admin: global.menu_admin
          .filter((e) => e.name)
          .map((e) => ({
            module: e.name,
            icon: e.icon,
            permission: e.permission.replaceAll(".read", ""),
            read: false,
            create: false,
            update: false,
            delete: false,
          })),
        customer: global.menu_customer
          .filter((e) => e.name)
          .map((e) => ({
            module: e.name,
            icon: e.icon,
            permission: e.permission.replaceAll(".read", ""),
            read: false,
            create: false,
            update: false,
            delete: false,
          })),
        mobile: [],
        warehouse: global.menu_warehouse
          .filter((e) => e.name)
          .map((e) => ({
            module: e.name,
            icon: e.icon,
            permission: e.permission.replaceAll(".read", ""),
            read: false,
            create: false,
            update: false,
            delete: false,
          })),
      },

      uid: "",
      name: "",
      permission: [],
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get();
  }

  Get = async () => {
    const { filter_search } = this.state;
    let data, count;
    loading(true);

    // จำลองการเรียก API
    let result = await GET("admin/roles", {
      page_size: 100,
      page: 0,
      data_search: filter_search,
    });

    if (result?.status) {
      data = result.data;
      count = result.pagination?.count || 0;
    }

    this.setState({ data, count });
    loading(false);
  };

  Create = async () => {
    const { name } = this.state;

    if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_role_name"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let body = {
        name,
        permission: ["users.read"],
      };

      let result = await POST("admin/roles", body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false });
        // this.Get(1);
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || "An error occurred.",
        );
      }
      loading(false);
    }
  };

  Update = async () => {
    const { uid, name, permissions } = this.state;

    if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_role_name"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      let permissionSet = new Set();

const addPermission = (item) => {
  if (item.read) permissionSet.add(item.permission + ".read");
  if (item.create) permissionSet.add(item.permission + ".create");
  if (item.update) permissionSet.add(item.permission + ".update");
  if (item.delete) permissionSet.add(item.permission + ".delete");
};

// console.log("permissions:", permissions);

// loop ทุก group
for (let item of permissions.admin || []) addPermission(item);
for (let item of permissions.customer || []) addPermission(item);
for (let item of permissions.warehouse || []) addPermission(item);

// แปลงกลับเป็น array
let permission = Array.from(permissionSet);

console.log(permission);
      // console.log("permission:", permission);
      loading(true);
      let body = {
        uid,
        name,
        permission: permission.length === 0 ? ["users.read"] : permission,
      };

      let result = !uid
        ? await POST("admin/roles", body)
        : await PUT("admin/roles/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false });
        // this.Get(1);
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || "An error occurred.",
        );
      }
      loading(false);
    }
  };

  // Helper สำหรับแปลงข้อความ Mock Data ให้เป็น Key
  getTranslateMockData = (text) => {
    if (!text) return "";
    let key = text
      .toLowerCase()
      .replace(/ \/ |\/|-/g, "_")
      .replace(/ /g, "_");
    return t(key) || text;
  };

   Delete = async (id) => {
        if (
          await alert(
            "",
            "warning",
            t("delete_item"),
            t("delete_desc"),
            t("confirm"),
            t("cancel"),
          )
        ) {
          loading(true);
          let result = await DELETE("admin/roles/" + id, null);
          if (result?.status === true) {
            alert("#", "success");
          } if(result.message === "Cannot delete or deactivate this item because it is in use"){
            alert('', 'warning', t('warning'), t('cannot_delete_role_in_use'));
          }
          loading(false);
        }
      };

  renderAdminPermissions = () => {
    const data = this.state.permissions.admin;
    return (
      <div className="table-responsive mt-3">
        <div className="d-flex justify-content-between align-items-end mb-2">
          <div className="text-secondary text-12">
            {t("config_admin_permissions")}
          </div>
          <div className="text-12 fw-bold pointer">
            <span
              className="text-primary"
              onClick={() => {
                let _data = this.state.permissions;
                _data.admin = _data.admin.map((d) => ({
                  ...d,
                  read: true,
                  create: true,
                  update: true,
                  delete: true,
                }));
                this.setState({ permissions: _data });
              }}
            >
              {t("select_all")}
            </span>{" "}
            <span className="text-secondary fw-normal mx-2">|</span>{" "}
            <span
              className="text-secondary"
              onClick={() => {
                let _data = this.state.permissions;
                _data.admin = _data.admin.map((d) => ({
                  ...d,
                  read: false,
                  create: false,
                  update: false,
                  delete: false,
                }));
                this.setState({ permissions: _data });
              }}
            >
              {t("clear_all")}
            </span>
          </div>
        </div>
        <table className="table table-hover align-middle">
          <thead>
            <tr className="text-dark fw-bold text-12 border-bottom">
              <th className="py-2 border-0">{t("module")}</th>
              <th className="py-2 border-0 text-center">{t("view")}</th>
              <th className="py-2 border-0 text-center">{t("create")}</th>
              <th className="py-2 border-0 text-center">{t("edit")}</th>
              <th className="py-2 border-0 text-center">
                {t("delete_action")}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr
                key={idx}
                className={
                  item.isHighlighted
                    ? "bg-warning-light border-bottom"
                    : "border-bottom"
                }
              >
                <td className="py-3">
                  <span className="icon text-primary me-2 text-14">
                    {item.icon}
                  </span>
                  <span className="text-dark text-14 fw-bold">
                    {t(item.module)}
                  </span>
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.read}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.admin[idx].read = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.create}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.admin[idx].create = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.update}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.admin[idx].update = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.delete}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.admin[idx].delete = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  renderCustomerPermissions = () => {
    const data = this.state.permissions.customer;
    return (
      <div className="table-responsive mt-3">
        <div className="d-flex justify-content-between align-items-end mb-2">
          <div className="text-secondary text-12">
            {t("config_admin_permissions")}
          </div>
          <div className="text-12 fw-bold pointer">
            <span
              className="text-primary"
              onClick={() => {
                let _data = this.state.permissions;
                _data.customer = _data.customer.map((d) => ({
                  ...d,
                  read: true,
                  create: true,
                  update: true,
                  delete: true,
                }));
                this.setState({ permissions: _data });
              }}
            >
              {t("select_all")}
            </span>{" "}
            <span className="text-secondary fw-normal mx-2">|</span>{" "}
            <span
              className="text-secondary"
              onClick={() => {
                let _data = this.state.permissions;
                _data.customer = _data.customer.map((d) => ({
                  ...d,
                  read: false,
                  create: false,
                  update: false,
                  delete: false,
                }));
                this.setState({ permissions: _data });
              }}
            >
              {t("clear_all")}
            </span>
          </div>
        </div>
        <table className="table table-hover align-middle">
          <thead>
            <tr className="text-dark fw-bold text-12 border-bottom">
              <th className="py-2 border-0">{t("module")}</th>
              <th className="py-2 border-0 text-center">{t("view")}</th>
              <th className="py-2 border-0 text-center">{t("create")}</th>
              <th className="py-2 border-0 text-center">{t("edit")}</th>
              <th className="py-2 border-0 text-center">
                {t("delete_action")}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr
                key={idx}
                className={
                  item.isHighlighted
                    ? "bg-warning-light border-bottom"
                    : "border-bottom"
                }
              >
                <td className="py-3">
                  <span className="icon text-primary me-2 text-14">
                    {item.icon}
                  </span>
                  <span className="text-dark text-14 fw-bold">
                    {t(item.module)}
                  </span>
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.read}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.customer[idx].read = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.create}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.customer[idx].create = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.update}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.customer[idx].update = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.delete}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.customer[idx].delete = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  renderMobilePermissions = () => {
    const data = this.state.permissions.mobile;
     return (
      <div className="table-responsive mt-3">
        <div className="d-flex justify-content-between align-items-end mb-2">
          <div className="text-secondary text-12">
            {t("config_admin_permissions")}
          </div>
          <div className="text-12 fw-bold pointer">
            <span
              className="text-primary"
              onClick={() => {
                let _data = this.state.permissions;
                _data.mobile = _data.mobile.map((d) => ({
                  ...d,
                  read: true,
                  create: true,
                  update: true,
                  delete: true,
                }));
                this.setState({ permissions: _data });
              }}
            >
              {t("select_all")}
            </span>{" "}
            <span className="text-secondary fw-normal mx-2">|</span>{" "}
            <span
              className="text-secondary"
              onClick={() => {
                let _data = this.state.permissions;
                _data.mobile = _data.mobile.map((d) => ({
                  ...d,
                  read: false,
                  create: false,
                  update: false,
                  delete: false,
                }));
                this.setState({ permissions: _data });
              }}
            >
              {t("clear_all")}
            </span>
          </div>
        </div>
        <table className="table table-hover align-middle">
          <thead>
            <tr className="text-dark fw-bold text-12 border-bottom">
              <th className="py-2 border-0">{t("module")}</th>
              <th className="py-2 border-0 text-center">{t("view")}</th>
              <th className="py-2 border-0 text-center">{t("create")}</th>
              <th className="py-2 border-0 text-center">{t("edit")}</th>
              <th className="py-2 border-0 text-center">
                {t("delete_action")}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr
                key={idx}
                className={
                  item.isHighlighted
                    ? "bg-warning-light border-bottom"
                    : "border-bottom"
                }
              >
                <td className="py-3">
                  <span className="icon text-primary me-2 text-14">
                    {item.icon}
                  </span>
                  <span className="text-dark text-14 fw-bold">
                    {t(item.module)}
                  </span>
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.read}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.mobile[idx].read = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.create}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.mobile[idx].create = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.update}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.mobile[idx].update = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.delete}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.mobile[idx].delete = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  renderWarehousePermissions = () => {
    const data = this.state.permissions.warehouse;
    return (
      <div className="table-responsive mt-3">
        <div className="d-flex justify-content-between align-items-end mb-2">
          <div className="text-secondary text-12">
            {t("config_admin_permissions")}
          </div>
          <div className="text-12 fw-bold pointer">
            <span
              className="text-primary"
              onClick={() => {
                let _data = this.state.permissions;
                _data.warehouse = _data.warehouse.map((d) => ({
                  ...d,
                  read: true,
                  create: true,
                  update: true,
                  delete: true,
                }));
                this.setState({ permissions: _data });
              }}
            >
              {t("select_all")}
            </span>{" "}
            <span className="text-secondary fw-normal mx-2">|</span>{" "}
            <span
              className="text-secondary"
              onClick={() => {
                let _data = this.state.permissions;
                _data.warehouse = _data.warehouse.map((d) => ({
                  ...d,
                  read: false,
                  create: false,
                  update: false,
                  delete: false,
                }));
                this.setState({ permissions: _data });
              }}
            >
              {t("clear_all")}
            </span>
          </div>
        </div>
        <table className="table table-hover align-middle">
          <thead>
            <tr className="text-dark fw-bold text-12 border-bottom">
              <th className="py-2 border-0">{t("module")}</th>
              <th className="py-2 border-0 text-center">{t("view")}</th>
              <th className="py-2 border-0 text-center">{t("create")}</th>
              <th className="py-2 border-0 text-center">{t("edit")}</th>
              <th className="py-2 border-0 text-center">
                {t("delete_action")}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr
                key={idx}
                className={
                  item.isHighlighted
                    ? "bg-warning-light border-bottom"
                    : "border-bottom"
                }
              >
                <td className="py-3">
                  <span className="icon text-primary me-2 text-14">
                    {item.icon}
                  </span>
                  <span className="text-dark text-14 fw-bold">
                    {t(item.module)}
                  </span>
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.read}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.warehouse[idx].read = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.create}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.warehouse[idx].create = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.update}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.warehouse[idx].update = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input pointer"
                    checked={item.delete}
                    onClick={(e) => {
                      let _data = this.state.permissions;
                      _data.warehouse[idx].delete = e.target.checked;
                      this.setState({ permissions: _data });
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    const {
      data,
      active_role_id,
      active_tab,
      selected_company,
      modal_create,
      name,
      permission,
    } = this.state;
    const activeRole = data?.find((r) => r.uid === active_role_id);

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          {/* Header Section */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
            <div>
              <h3 className="fw-bold mb-1 text-dark">
                {t("roles_and_permissions")}
              </h3>
              <div className="text-secondary text-14">
                {t("manage_roles_desc")}
              </div>
            </div>
            <button
              className="btn btn-primary px-4 fw-bold rounded-3 shadow-sm d-flex align-items-center"
              onClick={() =>
                this.setState({
                  modal_create: true,
                  uid: "",
                  name: "",
                  permission: [],
                })
              }
            >
              <span className="me-2 text-16">+</span> {t("add_role")}
            </button>
          </div>

          <div className="row g-4">
            {/* Left Panel: Roles List */}
            <div className="col-lg-4">
              <div className="bg-white rounded-4 shadow-sm p-4 h-100 border border-light">
                <div className="mb-3">
                  <h6 className="fw-bold text-dark mb-0">{t("roles")}</h6>
                  <div className="text-secondary text-12">
                    {data?.length} {t("roles_defined")}
                  </div>
                </div>

                <div className="d-flex flex-column gap-2">
                  {data?.map((role) => (
                    <div
                      key={role.uid}
                      className={`p-3 rounded-3 pointer transition-hover border ${active_role_id === role.uid ? "bg-primary-light border-primary" : "bg-white border-light hover-bg-light"}`}
                      onClick={() =>
                      {
                        console.log("ITEM:",role);
                        this.setState({ active_role_id: role.uid,
                          ...role,
                           permissions: {
        admin: global.menu_admin
          .filter((e) => e.name)
          .map((e) => ({
            module: e.name,
            icon: e.icon,
            permission: e.permission.replaceAll(".read", ""),
            read: role.permission.includes(e.permission.replaceAll(".read", "")+".read") ? true : false,
            create: role.permission.includes(e.permission.replaceAll(".read", "")+".create") ? true : false,
            update: role.permission.includes(e.permission.replaceAll(".read", "")+".update") ? true : false,
            delete: role.permission.includes(e.permission.replaceAll(".read", "")+".delete") ? true : false,
          })),
        customer: global.menu_customer
          .filter((e) => e.name)
          .map((e) => ({
            module: e.name,
            icon: e.icon,
            permission: e.permission.replaceAll(".read", ""),
            read: role.permission.includes(e.permission.replaceAll(".read", "")+".read") ? true : false,
            create: role.permission.includes(e.permission.replaceAll(".read", "")+".create") ? true : false,
            update: role.permission.includes(e.permission.replaceAll(".read", "")+".update") ? true : false,
            delete: role.permission.includes(e.permission.replaceAll(".read", "")+".delete") ? true : false,
          })),
        mobile: [],
        warehouse: global.menu_warehouse
          .filter((e) => e.name)
          .map((e) => ({
            module: e.name,
            icon: e.icon,
            permission: e.permission.replaceAll(".read", ""),
            read: role.permission.includes(e.permission.replaceAll(".read", "")+".read") ? true : false,
            create: role.permission.includes(e.permission.replaceAll(".read", "")+".create") ? true : false,
            update: role.permission.includes(e.permission.replaceAll(".read", "")+".update") ? true : false,
            delete: role.permission.includes(e.permission.replaceAll(".read", "")+".delete") ? true : false,
          })),
      },
                         })}
                      }
                    >
                      <div className="d-flex justify-content-between align-items-start mb-1">
                        <div
                          className={`fw-bold text-14 ${active_role_id === role.uid ? "text-primary" : "text-dark"}`}
                        >
                          {role.name}
                        </div>
                      </div>
                      <div className="text-secondary text-10 d-flex align-items-center">
                        <span className="icon me-1">{"\uf0c0"}</span>{" "}
                        {t("users")}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Panel: Permissions Config */}
            <div className="col-lg-8">
              {activeRole && (
              <div className="bg-white rounded-4 shadow-sm p-4 h-100 border border-light d-flex flex-column">
                {/* Header (Role Title & Action Buttons) */}
                <div className="d-flex justify-content-between align-items-start mb-4">
                  <div>
                    <h4 className="fw-bold text-dark mb-0">
                      {activeRole?.name}
                    </h4>
                  </div>
                </div>

                {/* Tabs */}
                <div className="d-flex border-bottom gap-4 mb-3">
                  <div
                    className={`pb-2 pointer fw-bold d-flex align-items-center ${active_tab === "admin" ? "text-primary" : "text-secondary"}`}
                    style={{
                      borderBottom:
                        active_tab === "admin" ? "3px #1976D2 solid" : "",
                    }}
                    onClick={() => this.setState({ active_tab: "admin" })}
                  >
                    <span className="icon me-2">{"\uf108"}</span>{" "}
                    {t("admin_portal")}
                  </div>
                  <div
                    className={`pb-2 pointer fw-bold d-flex align-items-center ${active_tab === "customer" ? "text-primary" : "text-secondary"}`}
                    style={{
                      borderBottom:
                        active_tab === "customer" ? "3px #1976D2 solid" : "",
                    }}
                    onClick={() => this.setState({ active_tab: "customer" })}
                  >
                    <span className="icon me-2">{"\uf007"}</span>{" "}
                    {t("customer_portal")}
                  </div>
                  <div
                    className={`pb-2 pointer fw-bold d-flex align-items-center ${active_tab === "mobile" ? "text-primary" : "text-secondary"}`}
                    style={{
                      borderBottom:
                        active_tab === "mobile" ? "3px #1976D2 solid" : "",
                    }}
                    onClick={() => this.setState({ active_tab: "mobile" })}
                  >
                    <span className="icon me-2">{"\uf10b"}</span>{" "}
                    {t("mobile_app")}
                  </div>
                  <div
                    className={`pb-2 pointer fw-bold d-flex align-items-center ${active_tab === "warehouse" ? "text-primary" : "text-secondary"}`}
                    style={{
                      borderBottom:
                        active_tab === "warehouse" ? "3px #1976D2 solid" : "",
                    }}
                    onClick={() => this.setState({ active_tab: "warehouse" })}
                  >
                    <span className="icon me-2">{"\uf494"}</span>{" "}
                    {t("warehouse_inventory")}
                  </div>
                </div>

                {/* Permissions Tables */}
                <div className="flex-grow-1">
                  {active_tab === "admin" && this.renderAdminPermissions()}
                  {active_tab === "customer" &&
                    this.renderCustomerPermissions()}
                  {active_tab === "mobile" && this.renderMobilePermissions()}
                  {active_tab === "warehouse" &&
                    this.renderWarehousePermissions()}
                </div>

                {/* Bottom Save Buttons */}
                <div className="d-flex justify-content-between gap-3 mt-4 pt-3 border-top">
                      <button className="btn btn-danger-light border-danger text-danger px-3 py-1 fw-bold rounded-2 d-flex align-items-center shadow-sm"
                      onClick={() => this.Delete(active_role_id)}>
                        <span className="icon me-2">{"\uf2ed"}</span>{" "}
                        {t("delete")}
                      </button>
                  <button className="btn btn-primary px-4 py-2 fw-bold rounded-2 d-flex align-items-center shadow-sm"
                  onClick={() => {this.Update()}}>
                    <span className="icon me-2">{"\uf0c7"}</span>{" "}
                    {t("save")}
                  </button>
                </div>
              </div>
              )}
            </div>
          </div>
        </div>

        {/* MODAL: ADD NEW ROLE */}
        <Modal
          size="md"
          show={modal_create}
          onHide={() => this.setState({ modal_create: false })}
          centered
          contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
        >
          <Modal.Header
            className="bg-white border-bottom px-4 py-3"
            closeButton
          >
            <h4 className="fw-bold mb-0 text-dark">{t("add_new_role")}</h4>
          </Modal.Header>

          <Modal.Body className="p-4 bg-white">
            <div className="d-flex flex-column gap-4">
              <div>
                <label className="form-label text-14 text-secondary fw-bold">
                  {t("role_name")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control py-2 text-dark"
                  placeholder={t("role_name_placeholder")}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </div>

              {/* <div>
                <label className="form-label text-14 text-secondary fw-bold">{t("description")}</label>
                <textarea 
                  className="form-control py-2 text-dark" 
                  rows="3" 
                  placeholder={t("role_desc_placeholder")}
                ></textarea>
              </div> */}
            </div>
          </Modal.Body>

          <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end gap-2 bg-light">
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={() => this.setState({ modal_create: false })}
            >
              {t("cancel")}
            </button>
            <button
              className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold text-white shadow-sm"
              style={{ backgroundColor: "#3b82f6", borderColor: "#3b82f6" }}
              onClick={() => this.Create()}
            >
              <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
